/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

function getCookie(cname) {
  try {
    var name = cname + '='
    var decodedCookie = decodeURIComponent(document.cookie)
    var ca = decodedCookie.split(';')
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i]
      while (c.charAt(0) === ' ') {
        c = c.substring(1)
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length)
      }
    }
    return ''  
  } catch (error) {
    // console.log("🚀 ~ file: utils.js ~ line 17 ~ getCookie ~ error",cname +" ----- "+ error)
    return ''
  }
  
}

function setCookie(cname, cvalue, exdays) {
  var d = new Date()
  if (typeof exdays === 'undefined') {
    exdays = 30
  }
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000)
  var expires = 'expires=' + d.toUTCString()
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/'
}

window.addEventListener('load', function() {

  /**
    KLAVIYO (profiling, msg and newsletter)
  */

  // Reset user locale
  _learnq.push(['identify', {
    'locale': document.documentElement.lang
  }])

  // Newsletter popup
  if ( getCookie('showNewsletter') !== 'true' ) {
    window.setTimeout(function() {
      window._klOnsite = window._klOnsite || [];

      window.addEventListener("klaviyoForms", function(e) { 
        if (e.detail.type === 'submit') {
            _learnq.push(['identify', {
              '$email': e.detail.metaData.$email,
              'locale': document.documentElement.lang
            }]) 
        }
      });
      switch (document.documentElement.lang) {
        case 'en':
          window._klOnsite.push(['openForm', 'XhVRfU', function() {
            console.log('form triggered')
          }]);
          break
        case 'fr':
          window._klOnsite.push(['openForm', 'WaFgqZ']);
          break
      }
      setCookie('showNewsletter', 'true', 30)
    }, 5000)
  }

  // identify user on newseltter sub
  let footerNewsletterEl = document.getElementById('footer-newsletter')
  if ( footerNewsletterEl !== null ) {
     footerNewsletterEl.addEventListener("submit", function(e){
       let email = document.getElementById('footer-newsletter-email').value
       let locale = document.getElementById('footer-newsletter-locale').value
       var _learnq = window._learnq || []
       //Adding custom properties. Note that Klaviyo understands different data types.
        _learnq.push(['identify', {
          '$email' : email,
          'locale': locale
        }])
     })
  }

  // track add to cart
  var atcButtons = document.querySelectorAll("form[action*='/cart/add'] button[type='submit']");
  for (var i = 0; i < atcButtons.length; i++) {
      atcButtons[i].addEventListener("click", function() {
        _learnq.push(['track', 'Added to Cart', item]);
      })
  }

  /**
    END KLAVIYO
  **/
})
